import * as request from "@/utils/request";
import { DefaultConfigs } from "@/common/js/constant";
import { HelpCenterRes } from "./types";
// import { setUrl } from '@/common/js/constant';

const baseUrl = `${DefaultConfigs.publicAPIPath}`;

// 查询客服信息
export function getHelpInfo() {
  return request.get<HelpCenterRes>(`${baseUrl}/sofipo/v0/helpCenter/pageInfo`, {});
}
